import React from "react";
import { Accordion } from "react-bootstrap";
import { useRouter } from "next/dist/client/router";
import { useIntl } from "react-intl";
const Faqs = ({ faqs }) => {
  const { locale, formatMessage } = useIntl();
  const renderFaqs = faqs?.map((faq, index) => {
    return (
      <Accordion.Item eventKey={"question" + index} key={"question" + index}>
        <Accordion.Header as="div">
          <span>{index + 1}</span>
          {faq?.question?.[locale]}
        </Accordion.Header>
        <Accordion.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: faq?.answer?.[locale],
            }}
          />
        </Accordion.Body>
      </Accordion.Item>
    );
  });

  return (
    <>
      <div className="faqs" data-aos-duration="300" data-aos-delay="100">
        <h3>{formatMessage({ id: "faqs" })}</h3>
        <Accordion defaultActiveKey={"question" + 0}>{renderFaqs}</Accordion>
      </div>
    </>
  );
};

export default Faqs;
